import NoMessagesScreen from '@/features/ai-chat/components/AskGXDrawer/NoMessagesScreen/NoMessagesScreen';
import { useChatState } from '@/features/ai-chat/state/useChat';
import { Box } from '@/shared/ui/layout/Box';

import MessageComponent from '../Messages/MessageComponent';
import { useChatScroll } from './useChatScroll';

const Chat = () => {
  const { messages } = useChatState();
  const bottomRef = useChatScroll(messages);

  if (messages.length === 0) return <NoMessagesScreen />;

  return (
    <Box
      sx={{
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        overflowY: 'auto',
        padding: '16px'
      }}
    >
      {messages.map((msg, index) => (
        <MessageComponent
          key={msg.id}
          index={index}
          msg={msg}
        />
      ))}
      <div ref={bottomRef} />
    </Box>
  );
};

export default Chat;
